export default __webpack_public_path__ + "static/media/bp_stage_1.db291f2f.svg";